import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { column } from "../helpers";
import {
  useVehicleMarkDelete,
  useVehicleMarkList,
  useVehicleMarkSet,
} from "../hooks";

export const VehicleTariffScreen = (props: any) => {
  let { vehicle_id } = useParams();
  if (!vehicle_id) {
    vehicle_id = props.vehicle_id;
  }
  const [activeMarkId, setActiveMarkId] = useState(null);
  const toast = useToast();
  const labelRef = useRef<HTMLInputElement>();
  const min_daysRef = useRef<HTMLInputElement>();
  const max_daysRef = useRef<HTMLInputElement>();
  const priceRef = useRef<HTMLInputElement>();
  const promo_priceRef = useRef<HTMLInputElement>();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList } =
    useVehicleMarkList();
  const { vehicleMarkSetLoading, getVehicleMarkSet } = useVehicleMarkSet();
  const { vehicleMarkDeleteReq, vehicleMarkDeleteLoading } =
    useVehicleMarkDelete();

  useEffect(() => {
    getVehicleMarkList(vehicle_id);
  }, [vehicle_id]);

  const loading =
    vehicleMarkListLoading || vehicleMarkSetLoading || vehicleMarkDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    const data = {
      label: labelRef?.current?.value || "",
      min_days: min_daysRef?.current?.value || "",
      max_days: max_daysRef?.current?.value || "",
      price: priceRef?.current?.value || "",
      promo_price: promo_priceRef?.current?.value || "",
      vehicle_id,
      id: activeMarkId,
    };
    const res = await getVehicleMarkSet(data);
    if (res.data.success) {
      toast({
        title: "Марка создана ",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    }
    getVehicleMarkList(vehicle_id);
    setModalIsOpen(false);
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Тарифы авто</Heading>}
        onClick={() => {
          setActiveMarkId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить тариф"
      >
        {loading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={column}>
            {vehicleMarkList.map(
              ({ id, label, min_days, max_days, price, promo_price }) => (
                <Tr key={id}>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {id}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {label}
                    </Text>{" "}
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {min_days}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {max_days}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {price}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {promo_price}
                    </Text>
                  </Td>
                  <Td isNumeric>
                    <FuncButton
                      onClick={() => {
                        setActiveMarkId(id);
                        setModalIsOpen(true);
                        setTimeout(() => {
                          labelRef.current.value = label;
                          min_daysRef.current.value = min_days;
                          max_daysRef.current.value = max_days;
                          priceRef.current.value = price;
                          promo_priceRef.current.value = promo_price;
                        }, 500);
                      }}
                    >
                      РЕДАКТИРОВАТЬ
                    </FuncButton>
                    <Button
                      marginLeft={"20px"}
                      colorScheme="red"
                      onClick={() => {
                        if (
                          window.confirm("Пожалуйста, подтвердите удаление")
                        ) {
                          vehicleMarkDeleteReq({ id }).then(() => {
                            getVehicleMarkList(vehicle_id);
                          });
                        }
                      }}
                    >
                      Удалить
                    </Button>
                  </Td>
                </Tr>
              )
            )}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить тариф</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <>
                <FormControl>
                  <FormLabel>Наименование (не обязательно)</FormLabel>
                  <Input ref={labelRef} placeholder="Наименование" />
                </FormControl>
                <FormControl marginTop={"20px"}>
                  <FormLabel>Дней аренды ("от")</FormLabel>
                  <Input ref={min_daysRef} placeholder="Дней аренды (от)" />
                </FormControl>
                <FormControl marginTop={"20px"}>
                  <FormLabel>Дней аренды ("до")</FormLabel>
                  <Input ref={max_daysRef} placeholder="Дней аренды (до)" />
                </FormControl>
                <FormControl marginTop={"20px"}>
                  <FormLabel>Цена (без скидки)</FormLabel>
                  <Input ref={priceRef} placeholder="Цена (без скидки)" />
                </FormControl>
                <FormControl marginTop={"20px"}>
                  <FormLabel>Цена со скидкой (не обязательно)</FormLabel>
                  <Input
                    ref={promo_priceRef}
                    placeholder="Цена со скидкой (не обязательно)"
                  />
                </FormControl>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeMarkId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
